'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _class2, _temp;
// import convert from '../../helpers/convert'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = require('react-redux');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reduxAsyncConnect = require('redux-async-connect');

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _reactSlidedown = require('react-slidedown');

var _Flip = require('react-reveal/Flip');

var _Flip2 = _interopRequireDefault(_Flip);

var _components = require('../../components');

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Styles = require('./FundGenderScore.css');

var GROUP_LABELS_FIELDNAMES = [['All funds', 'rank'], ['Groups', 'group'], ['Categories', 'peer']];

var DEFAULT_GROUP_TYPE = 'group';

var FundGenderScore = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.shareClass.result,
    loading: state.shareClass.loading,
    loaded: state.shareClass.loaded,
    error: state.shareClass.error,
    cart: state.cart.result
  };
}, searchActions), _dec2 = (0, _reduxAsyncConnect.asyncConnect)([{
  // need 'deferred' otherwise client navigate is blocked until page is loaded
  deferred: true,
  promise: function promise(_ref) {
    var params = _ref.params,
        _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    return dispatch(searchActions.shareClassDetails(params.fundId, params.investmentVehicleId));
  }
}]), _dec3 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FundGenderScore, _Component);

  function FundGenderScore(props) {
    (0, _classCallCheck3.default)(this, FundGenderScore);

    // init state has all slidedown flags false, and grouping at default
    // grouping state is not stored in redux, resets for each fund visit
    var _this = (0, _possibleConstructorReturn3.default)(this, (FundGenderScore.__proto__ || (0, _getPrototypeOf2.default)(FundGenderScore)).call(this, props));

    _this.clickViewStats = function () {
      _this.setState({ viewStats: !_this.state.viewStats });
    };

    _this.clickToggleCriteria = function (subscoreId) {
      var showCriteriaField = 'showCriteriaSubscore' + subscoreId;
      var newState = {};
      var subscoreIds = ['A', 'B', 'C', 'D'];
      subscoreIds.forEach(function (el) {
        if (el === subscoreId) {
          newState[showCriteriaField] = !_this.state[showCriteriaField];
        } else {
          newState['showCriteriaSubscore' + el] = false;
        }
      });
      _this.setState(newState);
    };

    _this.changeActiveGrouping = function (newGrouping) {
      if (typeof newGrouping === 'string' && newGrouping !== _this.state.activeGrouping && (newGrouping === 'rank' || newGrouping === 'peer' || newGrouping === 'group')) {
        _this.setState({
          groupsLoaded: false
        });

        // for loading animation
        setTimeout(function () {
          _this.setState({
            activeGrouping: newGrouping,
            groupsLoaded: true
          });
        }, _this.state.loadingTime);
      }
    };

    _this.scrollTo = function (id) {
      return function () {
        var ele = document.getElementById(id);
        window.scrollTo(ele.offsetLeft, ele.offsetTop);
      };
    };

    _this.closeAllTooltipsExcept = function (thisRef) {
      var allRefs = [
      // overall
      'refScoreContainer', 'refRankContainer', 'refPeerContainer', 'refGroupContainer',
      // A
      'refSubscoreAScoreContainer', 'refSubscoreARankContainer', 'refSubscoreAGroupContainer', 'refSubscoreAPeerContainer',
      // B
      'refSubscoreBScoreContainer', 'refSubscoreBRankContainer', 'refSubscoreBGroupContainer', 'refSubscoreBPeerContainer',
      // C
      'refSubscoreCScoreContainer', 'refSubscoreCRankContainer', 'refSubscoreCGroupContainer', 'refSubscoreCPeerContainer',
      // D
      'refSubscoreDScoreContainer', 'refSubscoreDRankContainer', 'refSubscoreDGroupContainer', 'refSubscoreDPeerContainer'];
      allRefs.map(function (ref) {
        if (ref !== thisRef) {
          var _el = _reactDom2.default.findDOMNode(_this[ref]);
          if (_el) {
            _reactTooltip2.default.hide(_el);
          }
        }
        return true;
      });
    };

    _this.generateTooltip = function (type) {
      var gefScoresState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // Using score state, we will build the HTML content inside this div
      // Some types of tooltips have different content if unranked/unscored

      var pluralizedHolding = _format2.default.maybePluralize(_this.props.result.fund.gef_count, 'holding');

      /*
      * OVERALL SCORES AND RANKS
      */
      var overallScoreUnscored = '\n      Equileap assigns a gender equality score to nearly 3,500 companies,\n      based on four sub-scores: gender balance in leadership and workforce;\n      equal compensation and work life balance; policies promoting gender\n      equality; and commitment, transparency, and accountability. For each\n      holding in a fund\'s portfolio that has been scored by Equileap, we use\n      the company gender equality scores to calculate a score for the mutual\n      fund. This fund is unscored, because none of the holdings are scored by\n      Equileap.\n    ';

      var overallScore = '\n      Equileap analyzes nearly 3,500 companies and assigns a <i>gender\n      equality score</i> between 0 and 100. These overall scores are based on\n      four sub-scores:\n      <ul>\n        <li>\n          Gender balance in leadership and workforce (40 possible points)\n        </li>\n        <li>\n          Equal compensation and work life balance (30 possible points)\n        </li>\n        <li>\n          Policies promoting gender equality (20 possible points)\n        </li>\n        <li>\n          Commitment, transparency, and accountability (10 possible points)\n        </li>\n      </ul>\n      Using this data, we calculate an overall gender equality score for each\n      mutual fund by:\n      <ul>\n        <li>\n          taking each stock in the portfolio that\'s been scored by Equileap\n        </li>\n        <li>\n          averaging those scores, weighted by market value\n        </li>\n      </ul>\n      This fund\n      had ' + gefScoresState.gefCount + ' scored ' + pluralizedHolding + ' with a\n      weighted average <i>gender equality\n      score</i> of ' + gefScoresState.gefUnnormalizedOverallScore + ' out of 100.\n    ';

      var overallRankUnscored = '\n      None of this fund\'s holdings were scored by Equileap. We couldn\'t\n      calculate any gender equality scores for this fund, and the fund was not\n      included in our rankings or assigned a grade.\n    ';
      var unrankedTooltip = '\n      Less than 1/3 of this fund\'s long holdings were scored by Equileap. When\n      the score coverage is below 33%, we remove the fund from our rankings to\n      increase accuracy.\n    ';

      var overallRank = '\n      Each fund\'s overall score is ranked against other U.S.-domiciled\n      stock-based mutual funds.\n      <ul style="padding-inline-start: 10px;">\n        <li>\n          This fund\'s score of ' + gefScoresState.gefOverallScore + ' points\n          ranked ' + gefScoresState.gefOverallRank + ' out\n          of ' + gefScoresState.normAllScored + ' scored funds\n        </li>\n        <li>\n          ' + gefScoresState.gefOverallPercentileRank + '% of all funds analyzed\n          scored the same or lower\n        </li>\n      </ul>\n    ';

      var peerRank = '\n      Each fund\'s overall score is ranked against other funds in the same\n      category.\n      <ul style="padding-inline-start: 10px;">\n        <li>\n          This fund\'s score of ' + gefScoresState.gefOverallScore + ' points\n          ranked ' + gefScoresState.gefOverallPeerRank + ' out\n          of ' + gefScoresState.normPeer + ' for\n          the <i>' + gefScoresState.morningstar_category_name + '</i> category\n        </li>\n        <li>\n          ' + gefScoresState.gefOverallPeerPercentileRank + '% of other funds in\n          the <i>' + gefScoresState.morningstar_category_name + '</i> category\n          scored the same or lower\n        </li>\n      </ul>\n    ';

      var groupRank = '\n      Each fund\'s overall score is ranked against other funds in the same\n      group of categories.\n      <ul style="padding-inline-start: 10px;">\n        <li>\n          This fund\'s score of ' + gefScoresState.gefOverallScore + ' points\n          ranked ' + gefScoresState.gefOverallGroupRank + ' out\n          of ' + gefScoresState.normGroup + ' for\n          the <i>' + gefScoresState.category_group + '</i> group\n        </li>\n        <li>\n          ' + gefScoresState.gefOverallGroupPercentileRank + '% of other funds in\n          the <i>' + gefScoresState.category_group + '</i> group scored the same or\n          lower\n        </li>\n        <li>\n          For a group percentile ranking\n          of ' + gefScoresState.gefOverallGroupPercentileRank + ', this fund earns\n          a grade of ' + gefScoresState.gefOverallGroupGrade + '\n        </li>\n      </ul>\n    ';

      /*
      * BALANCE/POLICIES SCORES
      */
      var subscoreAUnscored = '\n      Equileap assigns companies a <i>gender balance in leadership and\n      workforce score</i> between 0 and 40. We calculate a sub-score for each\n      fund by:\n      <ul style="padding-inline-start: 10px;">\n        <li>\n          taking each stock in the portfolio that\'s been scored by Equileap\n        </li>\n        <li>\n          averaging the scores, weighted by market value\n        </li>\n      </ul>\n      This fund is unscored, because none of the holdings are scored by\n      Equileap.\n    ';

      var subscoreAScore = '\n      Equileap assigns companies a <i>gender balance in leadership and\n      workforce score</i> between 0 and 40. We calculate a sub-score for each\n      fund by:\n      <ul style="padding-inline-start: 10px;">\n        <li>\n          taking each stock in the portfolio that\'s been scored by Equileap\n        </li>\n        <li>\n          averaging the scores, weighted by market value\n        </li>\n      </ul>\n      This fund\n      had ' + gefScoresState.gefCount + ' scored ' + pluralizedHolding + ' with a\n      weighted average <i>gender balance in leadership and workforce\n      score</i> of ' + gefScoresState.subscoreAScoreUnnormalized + ' out of 40,\n      rounded to ' + gefScoresState.subscoreAScore + ' points.\n    ';

      var subscoreBUnscored = '\n      Equileap assigns companies an <i>equal compensation and work life\n      balance score</i> between 0 and 30. We calculate a sub-score for each\n      fund by:\n      <ul style="padding-inline-start: 10px;">\n        <li>\n          taking each stock in the portfolio that\'s been scored by Equileap\n        </li>\n        <li>\n          averaging the scores, weighted by market value\n        </li>\n      </ul>\n      This fund is unscored, because none of the holdings are scored by\n      Equileap.\n    ';

      var subscoreBScore = '\n      Equileap assigns companies an <i>equal compensation and work life\n      balance score</i> between 0 and 30. We calculate a sub-score for each\n      fund by:\n      <ul style="padding-inline-start: 10px;">\n        <li>\n          taking each stock in the portfolio that\'s been scored by Equileap\n        </li>\n        <li>\n          averaging the scores, weighted by market value\n        </li>\n      </ul>\n      This fund\n      had ' + gefScoresState.gefCount + ' scored ' + pluralizedHolding + ' with a\n      weighted average <i>equal compensation and work life balance\n      score</i> of ' + gefScoresState.subscoreBScoreUnnormalized + ' out\n      of 30, rounded to ' + gefScoresState.subscoreBScore + ' points.\n    ';

      var subscoreCUnscored = '\n      Equileap assigns companies a <i>policies promoting gender equality\n      score</i> between 0 and 20. We calculate a sub-score for each\n      fund by:\n      <ul style="padding-inline-start: 10px;">\n        <li>\n          taking each stock in the portfolio that\'s been scored by Equileap\n        </li>\n        <li>\n          averaging the scores, weighted by market value\n        </li>\n      </ul>\n      This fund is unscored, because none of the holdings are scored by\n      Equileap.\n    ';

      var subscoreCScore = '\n      Equileap assigns companies a <i>policies promoting gender equality\n      score</i> between 0 and 20. We calculate a sub-score for each\n      fund by:\n      <ul style="padding-inline-start: 10px;">\n        <li>\n          taking each stock in the portfolio that\'s been scored by Equileap\n        </li>\n        <li>\n          averaging the scores, weighted by market value\n        </li>\n      </ul>\n      This fund\n      had ' + gefScoresState.gefCount + ' scored ' + pluralizedHolding + ' with a\n      weighted average <i>policies promoting gender equality\n      score</i> of ' + gefScoresState.subscoreCScoreUnnormalized + ' out\n      of 20, rounded to ' + gefScoresState.subscoreCScore + ' points.\n    ';

      var subscoreDUnscored = '\n      Equileap assigns companies a <i>commitment, transparency, and\n      accountability score</i> between 0 and 10. We calculate a sub-score for\n      each fund by:\n      <ul style="padding-inline-start: 10px;">\n        <li>\n          taking each stock in the portfolio that\'s been scored by Equileap\n        </li>\n        <li>\n          averaging the scores, weighted by market value\n        </li>\n      </ul>\n      This fund is unscored, because none of the holdings are scored by\n      Equileap.\n    ';

      var subscoreDScore = '\n      Equileap assigns companies a <i>commitment, transparency, and\n      accountability score</i> between 0 and 10. We calculate a sub-score for\n      each fund by:\n      <ul style="padding-inline-start: 10px;">\n        <li>\n          taking each stock in the portfolio that\'s been scored by Equileap\n        </li>\n        <li>\n          averaging the scores, weighted by market value\n        </li>\n      </ul>\n      This fund\n      had ' + gefScoresState.gefCount + ' scored ' + pluralizedHolding + ' with a\n      weighted average <i>commitment, transparency, and accountability\n      score</i> of ' + gefScoresState.subscoreDScoreUnnormalized + ' out\n      of 10, rounded to ' + gefScoresState.subscoreDScore + ' points.\n    ';

      /*
      * BALANCE/POLICIES RANKS
      */
      // A
      var subscoreARank = unrankedTooltip;
      var subscoreAGroup = unrankedTooltip;
      var subscoreAPeer = unrankedTooltip;
      var subscoreBRank = unrankedTooltip;
      var subscoreBGroup = unrankedTooltip;
      var subscoreBPeer = unrankedTooltip;
      var subscoreCRank = unrankedTooltip;
      var subscoreCGroup = unrankedTooltip;
      var subscoreCPeer = unrankedTooltip;
      var subscoreDRank = unrankedTooltip;
      var subscoreDGroup = unrankedTooltip;
      var subscoreDPeer = unrankedTooltip;
      if (!gefScoresState.isUnranked) {
        subscoreARank = '\n        Each fund\'s gender balance in leadership and workforce score is ranked\n        against other U.S. stock-based mutual funds.\n        <ul style="padding-inline-start: 10px;">\n          <li>\n            This fund\'s gender balance in leadership and workforce score\n            of ' + gefScoresState.subscoreAScore + ' points\n            ranked ' + gefScoresState.subscoreARank + ' out\n            of ' + gefScoresState.normAllScored + ' scored funds\n          </li>\n          <li>\n            ' + gefScoresState.subscoreAPercentileRank + '% of all funds analyzed\n            scored the same or lower\n          </li>\n        </ul>\n      ';
        subscoreAGroup = '\n        Each fund\'s gender balance in leadership and workforce score is ranked\n        against other funds in the same group of categories.\n        <ul style="padding-inline-start: 10px;">\n          <li>\n            This fund\'s gender balance in leadership and workforce score\n            of ' + gefScoresState.subscoreAScore + ' points\n            ranked ' + gefScoresState.subscoreAGroupRank + ' out\n            of ' + gefScoresState.normGroup + ' for\n            the <i>' + gefScoresState.category_group + '</i> group\n          </li>\n          <li>\n            ' + gefScoresState.subscoreAGroupPercentileRank + '% of other funds in\n            the <i>' + gefScoresState.category_group + '</i> group scored the same\n            or lower\n          </li>\n        </ul>\n      ';
        subscoreAPeer = '\n        Each fund\'s gender balance in leadership and workforce score is ranked\n        against other funds in the same category.\n        <ul style="padding-inline-start: 10px;">\n          <li>\n            This fund\'s gender balance in leadership and workforce score\n            of ' + gefScoresState.subscoreAScore + ' points\n            ranked ' + gefScoresState.subscoreAPeerRank + ' out\n            of ' + gefScoresState.normPeer + ' for\n            the <i>' + gefScoresState.morningstar_category_name + '</i> category\n          </li>\n          <li>\n            ' + gefScoresState.subscoreAPeerPercentileRank + '% of other funds in\n            the <i>' + gefScoresState.morningstar_category_name + '</i> category\n            scored the same or lower\n          </li>\n        </ul>\n      ';

        // B
        subscoreBRank = '\n        Each fund\'s equal compensation and work life balance score is ranked\n        against other U.S. stock-based mutual funds.\n        <ul style="padding-inline-start: 10px;">\n          <li>\n            This fund\'s equal compensation and work life balance score\n            of ' + gefScoresState.subscoreBScore + ' points\n            ranked ' + gefScoresState.subscoreBRank + ' out\n            of ' + gefScoresState.normAllScored + ' scored funds\n          </li>\n          <li>\n            ' + gefScoresState.subscoreBPercentileRank + '% of all funds analyzed\n            scored the same or lower\n          </li>\n        </ul>\n      ';
        subscoreBGroup = '\n        Each fund\'s equal compensation and work life balance score is ranked\n        against other funds in the same group of categories.\n        <ul style="padding-inline-start: 10px;">\n          <li>\n            This fund\'s equal compensation and work life balance score\n            of ' + gefScoresState.subscoreBScore + ' points\n            ranked ' + gefScoresState.subscoreBGroupRank + ' out\n            of ' + gefScoresState.normGroup + ' for\n            the <i>' + gefScoresState.category_group + '</i> group\n          </li>\n          <li>\n            ' + gefScoresState.subscoreBGroupPercentileRank + '% of other funds in\n            the <i>' + gefScoresState.category_group + '</i> group scored the same\n            or lower\n          </li>\n        </ul>\n      ';
        subscoreBPeer = '\n        Each fund\'s equal compensation and work life balance score is ranked\n        against other funds in the same category.\n        <ul style="padding-inline-start: 10px;">\n          <li>\n            This fund\'s equal compensation and work life balance score\n            of ' + gefScoresState.subscoreBScore + ' points\n            ranked ' + gefScoresState.subscoreBPeerRank + ' out\n            of ' + gefScoresState.normPeer + ' for\n            the <i>' + gefScoresState.morningstar_category_name + '</i> category\n          </li>\n          <li>\n            ' + gefScoresState.subscoreBPeerPercentileRank + '% of other funds in\n            the <i>' + gefScoresState.morningstar_category_name + '</i> category\n            scored the same or lower\n          </li>\n        </ul>\n      ';

        // C
        subscoreCRank = '\n        Each fund\'s policies promoting gender equality score is ranked against\n        other U.S. stock-based mutual funds.\n        <ul style="padding-inline-start: 10px;">\n          <li>\n            This fund\'s policies promoting gender equality score\n            of ' + gefScoresState.subscoreCScore + ' points\n            ranked ' + gefScoresState.subscoreCRank + ' out\n            of ' + gefScoresState.normAllScored + ' scored funds\n          </li>\n          <li>\n            ' + gefScoresState.subscoreCPercentileRank + '% of all funds analyzed\n            scored the same or lower\n          </li>\n        </ul>\n      ';
        subscoreCGroup = '\n        Each fund\'s policies promoting gender equality score is ranked against\n        other funds in the same group of categories.\n        <ul style="padding-inline-start: 10px;">\n          <li>\n            This fund\'s policies promoting gender equality score\n            of ' + gefScoresState.subscoreCScore + ' points\n            ranked ' + gefScoresState.subscoreCGroupRank + ' out\n            of ' + gefScoresState.normGroup + ' for\n            the <i>' + gefScoresState.category_group + '</i> group\n          </li>\n          <li>\n            ' + gefScoresState.subscoreCGroupPercentileRank + '% of other funds in\n            the <i>' + gefScoresState.category_group + '</i> group scored the same\n            or lower\n          </li>\n        </ul>\n      ';
        subscoreCPeer = '\n        Each fund\'s policies promoting gender equality score is ranked against\n        other funds in the same category.\n        <ul style="padding-inline-start: 10px;">\n          <li>\n            This fund\'s policies promoting gender equality score\n            of ' + gefScoresState.subscoreCScore + ' points\n            ranked ' + gefScoresState.subscoreCPeerRank + ' out\n            of ' + gefScoresState.normPeer + ' for\n            the <i>' + gefScoresState.morningstar_category_name + '</i> category\n          </li>\n          <li>\n            ' + gefScoresState.subscoreCPeerPercentileRank + '% of other funds in\n            the <i>' + gefScoresState.morningstar_category_name + '</i> category\n            scored the same or lower\n          </li>\n        </ul>\n      ';

        // D
        subscoreDRank = '\n        Each fund\'s commitment, transparency, and accountability score is\n        ranked against other U.S. stock-based mutual funds.\n        <ul style="padding-inline-start: 10px;">\n          <li>\n            This fund\'s commitment, transparency, and accountability score\n            of ' + gefScoresState.subscoreDScore + ' points\n            ranked ' + gefScoresState.subscoreDRank + ' out\n            of ' + gefScoresState.normAllScored + ' scored funds\n          </li>\n          <li>\n            ' + gefScoresState.subscoreCPercentileRank + '% of all funds analyzed\n            scored the same or lower\n          </li>\n        </ul>\n      ';
        subscoreDGroup = '\n        Each fund\'s commitment, transparency, and accountability score is\n        ranked against other funds in the same group of categories.\n        <ul style="padding-inline-start: 10px;">\n          <li>\n            This fund\'s commitment, transparency, and accountability score\n            of ' + gefScoresState.subscoreDScore + ' points\n            ranked ' + gefScoresState.subscoreDGroupRank + ' out\n            of ' + gefScoresState.normGroup + ' for\n            the <i>' + gefScoresState.category_group + '</i> group\n          </li>\n          <li>\n            ' + gefScoresState.subscoreDGroupPercentileRank + '% of other funds in\n            the <i>' + gefScoresState.category_group + '</i> group scored the same\n            or lower\n          </li>\n        </ul>\n      ';
        subscoreDPeer = '\n        Each fund\'s commitment, transparency, and accountability score is\n        ranked against other funds in the same category.\n        <ul style="padding-inline-start: 10px;">\n          <li>\n            This fund\'s commitment, transparency, and accountability score\n            of ' + gefScoresState.subscoreDScore + ' points\n            ranked ' + gefScoresState.subscoreDPeerRank + ' out\n            of ' + gefScoresState.normPeer + ' for\n            the <i>' + gefScoresState.morningstar_category_name + '</i> category\n          </li>\n          <li>\n            ' + gefScoresState.subscoreDPeerPercentileRank + '% of other funds in\n            the <i>' + gefScoresState.morningstar_category_name + '</i> category\n            scored the same or lower\n          </li>\n        </ul>\n      ';
      }

      var fin = '';

      // Switch tooltip content based on requested type of tooltip
      switch (type) {
        case 'overallScoreUnscored':
          fin = overallScoreUnscored;
          break;
        case 'overallScore':
          fin = overallScore;
          break;
        case 'overallRankUnscored':
          fin = overallRankUnscored;
          break;
        case 'overallRankUnranked':
          fin = unrankedTooltip;
          break;
        case 'overallRank':
          fin = overallRank;
          break;
        case 'peerRankUnscored':
          fin = overallRankUnscored;
          break;
        case 'peerRankUnranked':
          fin = unrankedTooltip;
          break;
        case 'peerRank':
          fin = peerRank;
          break;
        case 'groupRankUnscored':
          fin = overallRankUnscored;
          break;
        case 'groupRankUnranked':
          fin = unrankedTooltip;
          break;
        case 'groupRank':
          fin = groupRank;
          break;
        //
        //
        case 'subscoreAScoreUnscored':
          fin = subscoreAUnscored;
          break;
        case 'subscoreAScore':
          fin = subscoreAScore;
          break;
        case 'subscoreBScoreUnscored':
          fin = subscoreBUnscored;
          break;
        case 'subscoreBScore':
          fin = subscoreBScore;
          break;
        case 'subscoreCScoreUnscored':
          fin = subscoreCUnscored;
          break;
        case 'subscoreCScore':
          fin = subscoreCScore;
          break;
        case 'subscoreDScoreUnscored':
          fin = subscoreDUnscored;
          break;
        case 'subscoreDScore':
          fin = subscoreDScore;
          break;
        //
        //
        case 'subscoreARank':
          fin = subscoreARank;
          break;
        case 'subscoreAGroup':
          fin = subscoreAGroup;
          break;
        case 'subscoreAPeer':
          fin = subscoreAPeer;
          break;
        case 'subscoreBRank':
          fin = subscoreBRank;
          break;
        case 'subscoreBGroup':
          fin = subscoreBGroup;
          break;
        case 'subscoreBPeer':
          fin = subscoreBPeer;
          break;
        case 'subscoreCRank':
          fin = subscoreCRank;
          break;
        case 'subscoreCGroup':
          fin = subscoreCGroup;
          break;
        case 'subscoreCPeer':
          fin = subscoreCPeer;
          break;
        case 'subscoreDRank':
          fin = subscoreDRank;
          break;
        case 'subscoreDGroup':
          fin = subscoreDGroup;
          break;
        case 'subscoreDPeer':
          fin = subscoreDPeer;
          break;
        //
        //
        default:
          fin = "ERROR (shouldn't see this)";
          break;
      }

      return _format2.default.tooltipHtml(fin);
    };

    _this.generateSubscoreConfig = function (gefScoresState) {
      //
      var isUnscored = gefScoresState.isUnscored;

      // icons

      var subscoreAIcon = require('../../../static/images/GEF-icons-gender-balance-peer-rank.svg');
      var subscoreBIcon = require('../../../static/images/GEF-icons-gender-equality-peer-rank.svg');
      var subscoreCIcon = require('../../../static/images/GEF-icons-gender-equality-policies-rank.svg');
      var subscoreDIcon = require('../../../static/images/GEF-icons-gender-equality-policies-score.svg');

      // chart to show if fund is unscored
      var unscoredChart = _react2.default.createElement(
        'div',
        { styleName: 'subscores-col-ban' },
        _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-ban' }),
        '\xA0 Unscored'
      );

      // function to generate a chart for a subscore
      var mainSubscoreChart = function mainSubscoreChart(value, normalizedValue, outOf) {
        return _react2.default.createElement(
          'div',
          { styleName: 'subscores-col-score-figure' },
          value,
          _react2.default.createElement(
            'span',
            { styleName: 'subscores-col-score-figure-out-of' },
            '/',
            _format2.default.number(outOf * 100)
          )
        );
      };

      var subscoreConfig = {
        A: {
          chartValue: '-1',
          chartStyle: 'percentile-null',
          chartDisplay: unscoredChart,
          shortLabel: 'Gender balance in leadership and workforce',
          longLabel: 'Gender balance in leadership and workforce',
          icon: subscoreAIcon,
          tooltipRef: 'refSubscoreAScoreContainer',
          tooltipDataId: 'subscore-A-score-container',
          generateTooltipId: 'subscoreAScoreUnscored'
        },
        B: {
          chartValue: '-1',
          chartStyle: 'percentile-null',
          chartDisplay: unscoredChart,
          shortLabel: 'Equal compensation and work life balance',
          longLabel: 'Equal compensation and work life balance',
          icon: subscoreBIcon,
          tooltipRef: 'refSubscoreBScoreContainer',
          tooltipDataId: 'subscore-B-score-container',
          generateTooltipId: 'subscoreBScoreUnscored'
        },
        C: {
          chartValue: '-1',
          chartStyle: 'percentile-null',
          chartDisplay: unscoredChart,
          shortLabel: 'Policies promoting gender equality',
          longLabel: 'Policies promoting gender equality',
          icon: subscoreCIcon,
          tooltipRef: 'refSubscoreCScoreContainer',
          tooltipDataId: 'subscore-C-score-container',
          generateTooltipId: 'subscoreCScoreUnscored'
        },
        D: {
          chartValue: '-1',
          chartStyle: 'percentile-null',
          chartDisplay: unscoredChart,
          shortLabel: 'Commitment, transparency, and accountability',
          longLabel: 'Commitment, transparency, and accountability',
          icon: subscoreDIcon,
          tooltipRef: 'refSubscoreDScoreContainer',
          tooltipDataId: 'subscore-D-score-container',
          generateTooltipId: 'subscoreDScoreUnscored'
        }
      };

      var outOfs = {
        A: 0.4,
        B: 0.3,
        C: 0.2,
        D: 0.1
      };

      if (!isUnscored) {
        // subscore A
        var normalizedSubscoreA = gefScoresState.subscoreAScore / outOfs.A;
        subscoreConfig.A.generateTooltipId = 'subscoreAScore';
        subscoreConfig.A.chartValue = normalizedSubscoreA;
        subscoreConfig.A.chartStyle = _format2.default.scoreStyle(normalizedSubscoreA);
        subscoreConfig.A.chartDisplay = mainSubscoreChart(gefScoresState.subscoreAScore, // value
        normalizedSubscoreA, // normalizedValue
        outOfs.A // outOf
        );

        // subscore B
        var normalizedSubscoreB = gefScoresState.subscoreBScore / outOfs.B;
        subscoreConfig.B.generateTooltipId = 'subscoreBScore';
        subscoreConfig.B.chartValue = normalizedSubscoreB;
        subscoreConfig.B.chartStyle = _format2.default.scoreStyle(normalizedSubscoreB);
        subscoreConfig.B.chartDisplay = mainSubscoreChart(gefScoresState.subscoreBScore, // value
        normalizedSubscoreB, // normalizedValue
        outOfs.B // outOf
        );

        // subscore C
        var normalizedSubscoreC = gefScoresState.subscoreCScore / outOfs.C;
        subscoreConfig.C.generateTooltipId = 'subscoreCScore';
        subscoreConfig.C.chartValue = normalizedSubscoreC;
        subscoreConfig.C.chartStyle = _format2.default.scoreStyle(normalizedSubscoreC);
        subscoreConfig.C.chartDisplay = mainSubscoreChart(gefScoresState.subscoreCScore, // value
        normalizedSubscoreC, // normalizedValue
        outOfs.C // outOf
        );

        // subscore D
        var normalizedSubscoreD = gefScoresState.subscoreDScore / outOfs.D;
        subscoreConfig.D.generateTooltipId = 'subscoreDScore';
        subscoreConfig.D.chartValue = normalizedSubscoreD;
        subscoreConfig.D.chartStyle = _format2.default.scoreStyle(normalizedSubscoreD);
        subscoreConfig.D.chartDisplay = mainSubscoreChart(gefScoresState.subscoreDScore, // value
        normalizedSubscoreD, // normalizedValue
        outOfs.D // outOf
        );
      }

      return subscoreConfig;
      //
    };

    _this.renderGroupControl = function (actvGrp) {
      // Constants for groups are defined at top of file
      var params = GROUP_LABELS_FIELDNAMES;

      return _react2.default.createElement(
        'div',
        { styleName: 'active-group-control-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'active-group-control-lbl' },
          _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-cog fa-2x', nospace: true })
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'active-group-control-opt-wrp' },
          params.map(function (el, ix) {
            return _react2.default.createElement(
              'div',
              {
                key: 'grping_' + ix,
                styleName: actvGrp !== el[1] ? 'active-group-control-opt' : 'active-group-control-opt-actv',
                onClick: function onClick() {
                  _this.changeActiveGrouping(el[1]);
                }
              },
              _react2.default.createElement(
                'span',
                {
                  styleName: actvGrp !== el[1] ? 'crt-inv' : 'crt-vis'
                },
                _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-caret-right' })
              ),
              '\xA0',
              el[0]
            );
          })
        ),
        _react2.default.createElement(
          'div',
          {
            styleName: 'active-group-control-lbl',
            'data-multiline': true,
            'data-effect': 'solid',
            'data-tip': _format2.default.tooltipHtml('\n              Change the grouping used in the percentile ranking. You can\n              group funds in three ways:\n              <ul style="padding-inline-start: 10px;">\n                <li>\n                  All funds, ranking <i>all scored U.S. stock-based mutual\n                  funds and ETFs</i> against each other. This is the broadest\n                  setting.\n                </li>\n                <li>\n                  Groups, ranking funds against funds in the same <i>Group of\n                  Morningstar Categories</i>. This is the default setting.\n                </li>\n                <li>\n                  Categories, ranking funds against funds in the\n                  same <i>Morningstar Category</i>. This is the narrowest\n                  setting.\n                </li>\n              </ul>\n              Only the default setting, <i>Groups</i>, is assigned a letter\n              grade.\n              '),
            'data-for': 'group-control-lbl',
            'data-place': 'left',
            'data-html': true
          },
          _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-info-circle fa-2x', nospace: true })
        ),
        _react2.default.createElement(_reactTooltip2.default, { id: 'group-control-lbl' })
      );
    };

    _this.renderRankDescription = function (actGrp, nm, scrSt, lbl, actvRnk) {
      // adjust URL based on active grouping, so we load funds from that group
      // on the list page
      var url = '';
      if (actGrp === 'rank') {
        url = _config2.default.routes.list;
        return _react2.default.createElement(
          'div',
          { styleName: 'overall-rank-description' },
          _react2.default.createElement(
            'div',
            { styleName: 'overall-rank-raw-score' },
            _react2.default.createElement(
              'i',
              null,
              'Universe:'
            ),
            ' ',
            lbl
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'div',
            { styleName: 'overall-rank-raw-score' },
            _react2.default.createElement('br', null)
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'div',
            { styleName: 'overall-rank-raw-score' },
            _react2.default.createElement(
              'i',
              null,
              'Ranking:'
            ),
            ' ',
            actvRnk,
            ' out of ',
            nm,
            ' funds'
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: url },
            'See more funds',
            _react2.default.createElement(_components.LinkIcon, null)
          )
        );
      } else if (actGrp === 'group') {
        var gp = scrSt.category_group;
        url = _config2.default.routes.list + '?grp=' + encodeURIComponent(gp);
        return _react2.default.createElement(
          'div',
          { styleName: 'overall-rank-description' },
          _react2.default.createElement(
            'div',
            { styleName: 'overall-rank-raw-score' },
            _react2.default.createElement(
              'i',
              null,
              'Universe:'
            ),
            ' ',
            lbl
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'div',
            { styleName: 'overall-rank-raw-score' },
            _react2.default.createElement(
              'i',
              null,
              'Group:'
            ),
            ' ',
            gp
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'div',
            { styleName: 'overall-rank-raw-score' },
            _react2.default.createElement(
              'i',
              null,
              'Ranking:'
            ),
            ' ',
            actvRnk,
            ' out of ',
            nm,
            ' funds'
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: url },
            'See more funds from this group',
            _react2.default.createElement(_components.LinkIcon, null)
          )
        );
      } else if (actGrp === 'peer') {
        var ct = scrSt.morningstar_category_name;
        url = _config2.default.routes.list + '?fdc=' + encodeURIComponent(ct);
        return _react2.default.createElement(
          'div',
          { styleName: 'overall-rank-description' },
          _react2.default.createElement(
            'div',
            { styleName: 'overall-rank-raw-score' },
            _react2.default.createElement(
              'i',
              null,
              'Universe:'
            ),
            ' ',
            lbl
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'div',
            { styleName: 'overall-rank-raw-score' },
            _react2.default.createElement(
              'i',
              null,
              'Category:'
            ),
            ' ',
            ct
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'div',
            { styleName: 'overall-rank-raw-score' },
            _react2.default.createElement(
              'i',
              null,
              'Ranking:'
            ),
            ' ',
            actvRnk,
            ' out of ',
            nm,
            ' funds'
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: url },
            'See more funds from this category',
            _react2.default.createElement(_components.LinkIcon, null)
          )
        );
      }
    };

    _this.renderOverallScores = function (shareClass, fund, gefScoresState) {
      // load icons
      var overallScoreIcon = require('../../../static/images/GEF-icons-gender-equality-score.svg');
      var rankIcon = require('../../../static/images/GEF-icons-peer-rank.svg');

      // alias active grouping from state
      var actvGrp = _this.state.activeGrouping;

      // tooltip content if the fund is unranked
      var isUnrankedTooltip = _format2.default.tooltipHtml('\n        The percent of the fund\'s long-position holdings (including stocks,\n        bonds, and other asset types, but excluding short positions) made up\n        of stocks that are covered by the Equileap Company Gender Equality\n        Score universe. Must be at least 33% for a fund to be included in our\n        rankings and assigned a grade.\n      ');

      // tooltip content if the fund is unranked and zero percent rated
      var isZeroPercentRatedTooltip = _format2.default.tooltipHtml('\n        None of this fund\'s holdings were scored by Equileap. We couldn\'t\n        calculate any gender equality scores for this fund, and the fund was\n        not included in our rankings or assigned a grade.\n      ');

      // tooltip content if the fund is unranked, >0% rated
      var unrankedGtZeroPercentRatedTooltip = _format2.default.tooltipHtml('\n        Less than 1/3 of this fund\'s long holdings were scored by Equileap.\n        We calculated gender equality scores for this fund based on\n        the ' + gefScoresState.gefPercentRated + ' of the fund holdings that had\n        Equileap scores, but whenever the score coverage is below 1/3 (33%),\n        we remove the fund from our rankings to increase accuracy.\n      ');

      var activeGradeAsInt = _format2.default.gefGradeAsInt(gefScoresState.gefOverallGroupGrade);

      // setup empty variables for switch logic
      var label = '';
      var headlineLbl = '';
      var activeRank = null;
      var activePrank = null;
      var nrm = null;
      var tooltipLbl = null;

      // switch on active grouping ('rank', 'peer', or 'group')
      switch (actvGrp) {
        case 'rank':
          label = 'All funds';
          headlineLbl = 'Overall';
          activeRank = gefScoresState.gefOverallRank;
          activePrank = gefScoresState.gefOverallPercentileRank;
          nrm = gefScoresState.normAllScored;
          tooltipLbl = 'overallRank';
          break;
        case 'group':
          label = 'Groups';
          headlineLbl = 'Group';
          activeRank = gefScoresState.gefOverallGroupRank;
          activePrank = gefScoresState.gefOverallGroupPercentileRank;
          nrm = gefScoresState.normGroup;
          tooltipLbl = 'groupRank';
          break;
        case 'peer':
          label = 'Categories';
          headlineLbl = 'Category';
          activeRank = gefScoresState.gefOverallPeerRank;
          activePrank = gefScoresState.gefOverallPeerPercentileRank;
          nrm = gefScoresState.normPeer;
          tooltipLbl = 'peerRank';
          break;
        default:
          headlineLbl = 'ERR';
          label = "ERROR (shouldn't see this)";
          break;
      }

      var generateTooltipId = 'overallScoreUnscored';
      var overallScoreChart = _react2.default.createElement(_components.Chart, {
        gefScore: '-1',
        gefStyle: 'percentile-null',
        type: 'large'
      });
      if (!gefScoresState.isUnscored) {
        generateTooltipId = 'overallScore';
        overallScoreChart = _react2.default.createElement(_components.Chart, {
          gefScore: String(gefScoresState.gefOverallScore),
          gefStyle: _format2.default.scoreStyle(gefScoresState.gefOverallScore),
          type: 'large'
        });
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'overall-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'overall-container' },
          _react2.default.createElement(
            'div',
            { styleName: 'overall-score-container' },
            _react2.default.createElement(
              'div',
              {
                styleName: 'overall-score-container-inner',
                'data-multiline': true,
                'data-effect': 'solid',
                'data-place': 'bottom'
                // data-scroll-hide={false}
                , 'data-for': 'score-container',
                'data-html': true,
                'data-event': 'click focus',
                ref: function ref(_ref2) {
                  _this.refScoreContainer = _ref2;
                },
                'data-tip': _this.generateTooltip(generateTooltipId, gefScoresState)
              },
              _react2.default.createElement(
                'div',
                { styleName: 'overall-score-title' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'icon-label-wrap' },
                  _react2.default.createElement('img', {
                    src: overallScoreIcon,
                    alt: 'Gender equality score',
                    styleName: 'inline-icon'
                  }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'icon-label' },
                    'Gender equality score'
                  )
                )
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'div',
                { styleName: 'overall-score-chart-wrap' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'overall-score-chart' },
                  overallScoreChart
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'overall-score-text' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'overall-score-headline' },
                    'Overall score'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'overall-score-description' },
                    'Average Equileap Gender Equality Score of fund holdings, weighted by market value'
                  )
                )
              )
            ),
            _react2.default.createElement(_reactTooltip2.default, {
              id: 'score-container',
              globalEventOff: 'click',
              afterShow: function afterShow() {
                _this.closeAllTooltipsExcept('refScoreContainer');
              }
            })
          ),
          gefScoresState.isUnranked ? _react2.default.createElement(
            'div',
            { styleName: 'overall-peer-container' },
            _react2.default.createElement(
              'div',
              {
                styleName: 'overall-rank-container-inner',
                'data-multiline': true,
                'data-effect': 'solid',
                'data-place': 'bottom',
                'data-for': 'peer-container',
                'data-html': true,
                'data-event': 'click focus',
                ref: function ref(_ref4) {
                  _this.refPeerContainer = _ref4;
                },
                'data-tip': _this.generateTooltip(gefScoresState.gefPercentRated === '-100%' ? 'peerRankUnscored' : 'peerRankUnranked', gefScoresState)
              },
              _react2.default.createElement(
                'div',
                { styleName: 'overall-rank-title' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'icon-label-wrap' },
                  _react2.default.createElement('img', {
                    src: rankIcon,
                    alt: 'Peer rank',
                    styleName: 'inline-icon'
                  }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'icon-label' },
                    'Group ranking'
                  )
                )
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'div',
                { styleName: 'overall-rank-colorbar-wrap' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'overall-rank-colorbar-figure' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'overall-rank-colorbar-ban' },
                    _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-ban' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'overall-rank-colorbar-label' },
                    'Unranked'
                  )
                )
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'div',
                null,
                'Not ranked due to low data coverage'
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'div',
                { styleName: 'col-right' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'stats-label' },
                  '% Equileap coverage',
                  _react2.default.createElement(
                    'span',
                    {
                      'data-multiline': true,
                      'data-effect': 'solid',
                      'data-place': 'bottom',
                      'data-for': 'gef-percent-rated',
                      'data-html': true
                      // data-event='click focus'
                      // data-scroll-hide={false}
                      , 'data-tip': isUnrankedTooltip
                    },
                    _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-info-circle' }),
                    _react2.default.createElement(_reactTooltip2.default, { id: 'gef-percent-rated' })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'stats-value' },
                  /* display either the low percent rated, or 0%  */
                  gefScoresState.gefPercentRated === '-100%' ? '0%' : gefScoresState.gefPercentRated,
                  /* if rank is -1, the percent rated was too low */
                  _format2.default.number(fund.gef_rank) === '-1' ? _react2.default.createElement(
                    'span',
                    {
                      'data-multiline': true,
                      'data-effect': 'solid',
                      'data-place': 'bottom',
                      'data-for': 'low-percent-rated',
                      'data-html': true
                      // data-event='click focus'
                      , ref: function ref(_ref3) {
                        _this.refLowPercentRated = _ref3;
                      },
                      'data-tip': gefScoresState.gefPercentRated === '-100%' ? isZeroPercentRatedTooltip : unrankedGtZeroPercentRatedTooltip
                    },
                    _react2.default.createElement(_components.LinkIcon, {
                      faclass: 'fa-exclamation-triangle fa-2x'
                    }),
                    _react2.default.createElement(_reactTooltip2.default, { id: 'low-percent-rated' })
                  ) : null
                )
              )
            ),
            _react2.default.createElement(_reactTooltip2.default, {
              id: 'peer-container',
              globalEventOff: 'click',
              afterShow: function afterShow() {
                _this.closeAllTooltipsExcept('refPeerContainer');
              }
            })
          ) :
          /* if the fund is ranked: render the peer rank container */
          _react2.default.createElement(
            'div',
            { styleName: 'overall-peer-container' },
            _react2.default.createElement(
              _Flip2.default,
              { top: true, opposite: true, when: _this.state.groupsLoaded },
              _react2.default.createElement(
                'div',
                {
                  styleName: 'overall-rank-container-inner',
                  'data-multiline': true,
                  'data-effect': 'solid',
                  'data-place': 'bottom',
                  'data-for': 'peer-container',
                  'data-html': true,
                  'data-event': 'click focus',
                  ref: function ref(_ref5) {
                    _this.refPeerContainer = _ref5;
                  },
                  'data-tip': _this.generateTooltip(tooltipLbl, gefScoresState)
                },
                _react2.default.createElement(
                  'div',
                  { styleName: 'overall-rank-title' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'icon-label-wrap' },
                    _react2.default.createElement('img', {
                      src: rankIcon,
                      alt: 'Peer rank',
                      styleName: 'inline-icon'
                    }),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'icon-label' },
                      headlineLbl,
                      ' ranking'
                    )
                  )
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'div',
                  { styleName: 'overall-rank-colorbar-grade-wrap' },
                  _this.state.activeGrouping === 'group' ? _react2.default.createElement(
                    'div',
                    { styleName: 'reportcard-result-grade' },
                    _react2.default.createElement(_components.Grade, { grade: activeGradeAsInt, large: true })
                  ) : null,
                  _react2.default.createElement(
                    'div',
                    { styleName: 'overall-rank-colorbar-wrap' },
                    _react2.default.createElement('div', {
                      styleName: 'overall-rank-colorbar ' + _format2.default.scoreStyle(activePrank)
                    }),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'overall-rank-colorbar-figure' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'overall-rank-colorbar-score' },
                        activePrank
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'overall-rank-colorbar-label' },
                        'percentile'
                      )
                    )
                  )
                ),
                _react2.default.createElement('br', null),
                /* render the rank description */
                _this.renderRankDescription(actvGrp, nrm, fund, label, activeRank)
              )
            ),
            _react2.default.createElement(_reactTooltip2.default, {
              id: 'peer-container',
              globalEventOff: 'click',
              afterShow: function afterShow() {
                _this.closeAllTooltipsExcept('refPeerContainer');
              }
            })
          ),
          !gefScoresState.isUnranked ? _this.renderGroupControl(actvGrp) : null
        )
      );
    };

    _this.renderSubscoreScore = function (subscoreId, subscoreConfig, gefScoresState) {
      //
      var cnfg = subscoreConfig[subscoreId];

      return _react2.default.createElement(
        _reactFlexboxGrid.Col,
        { styleName: 'subscores-col', md: 3, sm: 6, xs: 12 },
        _react2.default.createElement(
          'div',
          {
            styleName: 'subscores-col-inner',
            'data-multiline': true,
            'data-effect': 'solid',
            'data-place': 'bottom',
            'data-for': cnfg.tooltipDataId,
            'data-html': true,
            'data-event': 'click focus',
            ref: function ref(_ref6) {
              _this[cnfg.tooltipRef] = _ref6;
            },
            'data-tip': _this.generateTooltip(cnfg.generateTooltipId, gefScoresState)
          },
          _react2.default.createElement(
            'div',
            { styleName: 'subscores-col-title-wrap' },
            _react2.default.createElement('img', {
              src: cnfg.icon,
              alt: cnfg.shortLabel,
              styleName: 'inline-icon-sm'
            }),
            _react2.default.createElement(
              'div',
              { styleName: 'subscores-col-title' },
              cnfg.shortLabel
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'subscores-col-chart-wrap' },
            _react2.default.createElement(_components.Chart, {
              gefScore: String(cnfg.chartValue),
              gefStyle: cnfg.chartStyle,
              type: 'small'
            }),
            cnfg.chartDisplay
          )
        ),
        _react2.default.createElement(
          'div',
          {
            styleName: 'subscores-col-methodology-button',
            onClick: function onClick() {
              _this.clickToggleCriteria(subscoreId);
            }
          },
          'See the score criteria',
          _react2.default.createElement(_components.LinkIcon, {
            faclass: _this.state['showCriteriaSubscore' + subscoreId] ? 'fa-angle-up' : 'fa-angle-down'
          })
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'visible-xs' },
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            _this.state.showCriteriaSubscoreA && subscoreId === 'A' ? _this.renderSubscoreMethodology('A') : null
          ),
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            _this.state.showCriteriaSubscoreB && subscoreId === 'B' ? _this.renderSubscoreMethodology('B') : null
          ),
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            _this.state.showCriteriaSubscoreC && subscoreId === 'C' ? _this.renderSubscoreMethodology('C') : null
          ),
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            _this.state.showCriteriaSubscoreD && subscoreId === 'D' ? _this.renderSubscoreMethodology('D') : null
          )
        ),
        _react2.default.createElement(_reactTooltip2.default, {
          id: cnfg.tooltipDataId,
          globalEventOff: 'click',
          afterShow: function afterShow() {
            _this.closeAllTooltipsExcept(cnfg.tooltipRef);
          }
        })
      );
    };

    _this.renderSubscoreScores = function (shareClass, fund, gefScoresState) {
      //
      var subscoreConfig = _this.generateSubscoreConfig(gefScoresState);
      //
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'subscores-wrap' },
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            { styleName: 'subscores-row' },
            _this.renderSubscoreScore('A', subscoreConfig, gefScoresState),
            _this.renderSubscoreScore('B', subscoreConfig, gefScoresState),
            _this.renderSubscoreScore('C', subscoreConfig, gefScoresState),
            _this.renderSubscoreScore('D', subscoreConfig, gefScoresState)
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'hidden-xs' },
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            _this.state.showCriteriaSubscoreA ? _this.renderSubscoreMethodology('A') : null
          ),
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            _this.state.showCriteriaSubscoreB ? _this.renderSubscoreMethodology('B') : null
          ),
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            _this.state.showCriteriaSubscoreC ? _this.renderSubscoreMethodology('C') : null
          ),
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            _this.state.showCriteriaSubscoreD ? _this.renderSubscoreMethodology('D') : null
          )
        )
      );
    };

    _this.renderSubscoreMethodology = function (subscoreId) {
      // subscore A
      if (subscoreId === 'A') {
        return _react2.default.createElement(
          'div',
          { styleName: 'score-criteria' },
          _react2.default.createElement(
            'div',
            { styleName: 'score-criteria-title' },
            'Score criteria: Gender balance in leadership and workforce'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Companies can earn up to 40 points for the gender balance in leadership and workforce category.'
          ),
          _react2.default.createElement(
            'ol',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Board of Directors'
              ),
              ' - Percentage of male and female Board of Directors as a proportion of the total number. Where the company has a Supervisory Board and a Management Board, this refers to the Supervisory Board.'
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Executives'
              ),
              ' - Percentage of male and female Executives as a percentage of the total number. Executives are as defined by the company or represent those individuals that form the company Executive Committee/Board or Management Committee/Board or equivalent.'
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Senior Management'
              ),
              ' - Percentage of male and female senior managers as a percentage of total. Senior Management are defined and reported by the company.'
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Workforce'
              ),
              ' - Ratio of each gender in Senior Management compared to ratio of each gender in the Workforce.'
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Promotion and Career Development Opportunities'
              ),
              ' - Ratio of each gender in senior management compared to ratio of each gender in the workforce'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.routes.howitworks,
                alt: 'How it works | Gender Equality Funds',
                xstrong: true
              },
              'See the full Gender Equality Funds methodology',
              _react2.default.createElement(_components.LinkIcon, null)
            )
          )
        );
      }
      // subscore B
      if (subscoreId === 'B') {
        return _react2.default.createElement(
          'div',
          { styleName: 'score-criteria' },
          _react2.default.createElement(
            'div',
            { styleName: 'score-criteria-title' },
            'Score criteria: Equal compensation and work life balance'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Companies can earn up to 30 points for the equal compensation and work life balance category.'
          ),
          _react2.default.createElement(
            'ol',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Living Wage'
              ),
              ' - Commitment to ensure payment of a living wage to all employees, even in those countries that do not legally require a minimum wage or where minimum wage is not a living wage.'
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Gender Pay Gap'
              ),
              ' - Commitment to provide comparable wages for comparable work and to close the gender pay gap.'
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Parental Leave'
              ),
              ' - Paid leave programs (at least 2/3 paid) for child care to both primary or secondary carers globally or at least in the country of incorporation.'
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Flexible Work Options'
              ),
              ' - Option for employees to control and/or vary the start and end times of the work day and/or vary the location from which employees work.'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.routes.howitworks,
                alt: 'How it works | Gender Equality Funds',
                xstrong: true
              },
              'See the full Gender Equality Funds methodology',
              _react2.default.createElement(_components.LinkIcon, null)
            )
          )
        );
      }
      // subscore C
      if (subscoreId === 'C') {
        return _react2.default.createElement(
          'div',
          { styleName: 'score-criteria' },
          _react2.default.createElement(
            'div',
            { styleName: 'score-criteria-title' },
            'Score criteria: Policies promoting gender equality'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Companies can earn up to 20 points for the policies promoting gender equality category.'
          ),
          _react2.default.createElement(
            'ol',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Training and Career Development'
              ),
              ' - Commitment to ensure equal access to training and career development to both men and women.'
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Recruitment Strategy'
              ),
              ' - Commitment to ensure non-discrimination against any type of demographic group and equal opportunities to ensure gender parity.'
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Freedom from Violence, Abuse, and Sexual Harassment'
              ),
              ' - Prohibits all forms of violence in the work place, including verbal, physical and sexual harassment.'
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Safety at Work'
              ),
              ' - Commitment to the safety of employees in the workplace, in travel to and from the workplace, and on company related business, and ensure the safety of vendors in the workplace.'
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Human Rights'
              ),
              ' - Commitment to ensure the protection of the rights of all people it works with including employees\u2019 rights to participate in legal, civic and political affairs.'
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Social Supply Chain'
              ),
              ' - Commitment to reduce social risks in its supply chain such as forbid business related activities that condone, support, or otherwise participate in trafficking, including for labour or sexual exploitation.'
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Supplier Diversity'
              ),
              ' - Commitment to ensure diversity in the supply chain, including support for women owned businesses in the supply chain.'
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Employee Protection'
              ),
              ' - Systems and policies for the reporting of internal ethical compliance complaints without retaliation or retribution, including but not limited to access to confidential third-party ethics hotlines or systems for confidential written complaints.'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.routes.howitworks,
                alt: 'How it works | Gender Equality Funds',
                xstrong: true
              },
              'See the full Gender Equality Funds methodology',
              _react2.default.createElement(_components.LinkIcon, null)
            )
          )
        );
      }
      // subscore D
      if (subscoreId === 'D') {
        return _react2.default.createElement(
          'div',
          { styleName: 'score-criteria' },
          _react2.default.createElement(
            'div',
            { styleName: 'score-criteria-title' },
            'Score criteria: Commitment, transparency, and accountability'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Companies can earn up to 10 points for the commitment, transparency, and accountability category.'
          ),
          _react2.default.createElement(
            'ol',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Commitment to Women\'s Empowerment'
              ),
              ' - Recognition and commitment to ensuring women\u2019s empowerment in the workplace.'
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Audit'
              ),
              ' - Undertaken and awarded an independent gender audit certificate by an Equileap recognized body.'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.routes.howitworks,
                alt: 'How it works | Gender Equality Funds',
                xstrong: true
              },
              'See the full Gender Equality Funds methodology',
              _react2.default.createElement(_components.LinkIcon, null)
            )
          )
        );
      }
    };

    _this.renderSubscoreMore = function (shareClass, fund, gefScoresState) {
      // if unscored, no button to show rankings.
      if (gefScoresState.isUnranked) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        null,
        _this.renderViewSubscoreRanksButton(shareClass),
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          null,
          _this.state.viewSubscoreRanks ? _this.renderSubscoreRanks(shareClass, fund, gefScoresState) : null
        )
      );
    };

    _this.renderViewSubscoreRanksButton = function (shareClass) {
      var label = !_this.state.viewSubscoreRanks ? 'View more rankings' : 'View less';

      return _react2.default.createElement(
        'div',
        { styleName: 'view-balance-policies-more-wrapper' },
        _react2.default.createElement(
          'button',
          {
            styleName: 'slidedown-button',
            title: label,
            onClick: function onClick() {
              _this.setState({
                viewSubscoreRanks: !_this.state.viewSubscoreRanks
              });
            } },
          label,
          _react2.default.createElement(_components.LinkIcon, {
            faclass: _this.state.viewSubscoreRanks ? 'fa-angle-up' : 'fa-angle-down'
          })
        ),
        _react2.default.createElement(
          'button',
          {
            styleName: 'compare-button',
            title: 'Compare to other funds',
            onClick: function onClick() {
              if (_this.props.cart && _this.props.cart.results) {
                // has cart results
                var isInCartAlready = false;
                var emptySpots = false;
                _this.props.cart.results.forEach(function (result) {
                  var stubId = result.shareclassStub.investment_vehicle_id;
                  if (stubId === shareClass.investment_vehicle_id) {
                    isInCartAlready = true;
                  } else if (result.id === 'N') {
                    emptySpots = true;
                  }
                });
                if (isInCartAlready) {
                  // found the shareclass in the cart already
                  _this.props.cartChange(_this.props.cart.results, {});
                } else {
                  // did not find the shareclass in the cart already
                  if (emptySpots) {
                    // cart not full - add the shareclass to the cart
                    _this.props.cartChange(_this.props.cart.results, shareClass);
                  } else {
                    // cart was full - kick the last out of the cart
                    var size = _this.props.cart.results.length - 1;
                    var newCart = _this.props.cart.results.slice(0, size);
                    newCart.push({ id: 'N', shareclassStub: {} });
                    _this.props.cartChange(newCart, shareClass);
                  }
                }
              } else {
                // did not have cart results
                _this.props.cartChange([], shareClass);
              }
              // go to list with this new cart
              _this.context.router.push(_config2.default.routes.clean);
            }
          },
          'Compare to other funds',
          _react2.default.createElement(_components.LinkIcon, null)
        )
      );
    };

    _this.renderSubscoreRank = function (subscoreId, gefScoresState, colorbarStyle, colorbarLabel, rankIcon) {
      var _linkIcon = function _linkIcon() {
        return _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-ban' });
      };
      // balance or policies -rank-container
      var containerStyleName = 'subscore-' + subscoreId + '-rank-container';

      var subscoreTitles = {
        A: 'Gender balance in leadership and workforce',
        B: 'Equal compensation and work life balance',
        C: 'Policies promoting gender equality',
        D: 'Commitment, transparency, and accountability'
      };

      var containerLabel = 'Ranking: ' + subscoreTitles[subscoreId];

      var fieldLabel = '';
      var rawFieldLabel = '';
      var norm = '';
      var label = '';
      var containerTooltipName = '';
      var containerRefName = '';

      // switch on active grouping ('rank', 'peer', or 'group')
      switch (_this.state.activeGrouping) {
        case 'rank':
          label = 'All funds';
          fieldLabel = 'subscore' + subscoreId + 'PercentileRank';
          rawFieldLabel = 'subscore' + subscoreId + 'Rank';
          norm = gefScoresState.normAllScored;
          containerTooltipName = 'subscore' + subscoreId + 'Rank';
          break;
        case 'peer':
          label = 'Categories';
          fieldLabel = 'subscore' + subscoreId + 'PeerPercentileRank';
          rawFieldLabel = 'subscore' + subscoreId + 'PeerRank';
          norm = gefScoresState.normPeer;
          containerTooltipName = 'subscore' + subscoreId + 'Peer';
          break;
        case 'group':
          label = 'Groups';
          fieldLabel = 'subscore' + subscoreId + 'GroupPercentileRank';
          rawFieldLabel = 'subscore' + subscoreId + 'GroupRank';
          norm = gefScoresState.normGroup;
          containerTooltipName = 'subscore' + subscoreId + 'Group';
          break;
      }

      var capRefName = containerTooltipName.charAt(0).toUpperCase() + containerTooltipName.slice(1);
      containerRefName = 'ref' + capRefName + 'Container';

      var rank = _linkIcon();
      var rankStyle = 'percentile-null';
      var rawRank = _react2.default.createElement(
        'em',
        null,
        'N/A'
      );
      // if not unranked:
      if (!gefScoresState.isUnranked) {
        rank = gefScoresState[fieldLabel];
        rankStyle = _format2.default.scoreStyle(gefScoresState[fieldLabel]);
        rawRank = '' + gefScoresState[rawFieldLabel];
      }
      var allRankIcon = require('../../../static/images/GEF-icons-peer-rank.svg');

      return _react2.default.createElement(
        _reactFlexboxGrid.Col,
        { styleName: 'subscore-ranks-col', md: 6, sm: 12 },
        _react2.default.createElement(
          'div',
          {
            styleName: 'subscore-rank-container',
            'data-multiline': true,
            'data-effect': 'solid',
            'data-place': 'bottom',
            'data-for': containerStyleName,
            'data-html': true,
            'data-event': 'click focus',
            ref: function ref(_ref7) {
              _this[containerRefName] = _ref7;
            },
            'data-tip': _this.generateTooltip(containerTooltipName, gefScoresState)
          },
          _react2.default.createElement(
            'div',
            { styleName: 'subscores-col-title-wrap' },
            _react2.default.createElement('img', {
              src: rankIcon,
              alt: containerLabel,
              styleName: 'inline-icon-sm'
            }),
            _react2.default.createElement('img', {
              src: allRankIcon,
              alt: containerLabel,
              styleName: 'inline-icon-sm'
            }),
            _react2.default.createElement(
              'div',
              { styleName: 'subscores-col-title' },
              containerLabel
            )
          ),
          _react2.default.createElement(
            _Flip2.default,
            { top: true, opposite: true, when: _this.state.groupsLoaded },
            _react2.default.createElement(
              'div',
              { styleName: 'balance-policies-ranks-container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'balance-policies-score-chart-wrap' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'balance-policies-colorbar-wrap' },
                  _react2.default.createElement('div', { styleName: 'balance-policies-colorbar ' + rankStyle }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'balance-policies-colorbar-figure' },
                    _react2.default.createElement(
                      'div',
                      { styleName: colorbarStyle },
                      rank
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'balance-policies-colorbar-label' },
                      colorbarLabel
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'balance-policies-score-copy' },
                _this.renderRankDescription(_this.state.activeGrouping, norm, gefScoresState, label, rawRank)
              )
            )
          )
        ),
        _react2.default.createElement(_reactTooltip2.default, {
          id: containerStyleName,
          globalEventOff: 'click',
          afterShow: function afterShow() {
            _this.closeAllTooltipsExcept(containerRefName);
          }
        })
      );
    };

    _this.renderSubscoreRanks = function (shareClass, fund, gefScoresState) {
      // extra logic to deal with unranked funds
      // inline component with 'unranked' icon
      var isUnranked = gefScoresState.isUnranked;

      var colorbarStyle = 'balance-policies-colorbar-';
      var suffix = isUnranked ? 'ban' : 'score';
      colorbarStyle += suffix;
      var colorbarLabel = isUnranked ? 'Unranked' : 'percentile';
      // icons
      var subscoreAIcon = require('../../../static/images/GEF-icons-gender-balance-peer-rank.svg');
      var subscoreBIcon = require('../../../static/images/GEF-icons-gender-equality-peer-rank.svg');
      var subscoreCIcon = require('../../../static/images/GEF-icons-gender-equality-policies-rank.svg');
      var subscoreDIcon = require('../../../static/images/GEF-icons-gender-equality-policies-score.svg');
      return _react2.default.createElement(
        'div',
        { styleName: 'subscore-ranks-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'subscore-ranks-rows' },
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            { styleName: 'subscore-ranks-row' },
            _this.renderSubscoreRank('A', gefScoresState, colorbarStyle, colorbarLabel, subscoreAIcon),
            _this.renderSubscoreRank('B', gefScoresState, colorbarStyle, colorbarLabel, subscoreBIcon)
          ),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            { styleName: 'subscore-ranks-row' },
            _this.renderSubscoreRank('C', gefScoresState, colorbarStyle, colorbarLabel, subscoreCIcon),
            _this.renderSubscoreRank('D', gefScoresState, colorbarStyle, colorbarLabel, subscoreDIcon)
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'subscore-ranks-group-control' },
          _this.renderGroupControl(_this.state.activeGrouping)
        )
      );
    };

    _this.renderMore = function (shareClass, fund, gefScoresState) {
      var label = !_this.state.viewStats ? 'View more info' : 'View less';
      var iconClass = _this.state.viewStats ? 'fa-angle-up' : 'fa-angle-down';
      return _react2.default.createElement(
        'div',
        { styleName: 'more-stats' },
        _react2.default.createElement(
          'div',
          { styleName: 'view-more-wrapper' },
          _react2.default.createElement(
            'button',
            {
              styleName: 'view-more',
              title: label,
              onClick: _this.clickViewStats
            },
            label,
            _react2.default.createElement(_components.LinkIcon, { faclass: iconClass })
          )
        ),
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          { styleName: 'slide-down' },
          _this.state.viewStats ? _this.renderStats(shareClass, fund, gefScoresState) : null
        )
      );
    };

    _this.renderStats = function (shareClass, fund, gefScoresState) {
      /**
       * Render a stats column. Each column has a list of entries. Each entry is
       * an object with name, value, and possibly link. A container is created
       * that displays the labeled value and links out if needed.
       *
       * @param  {String} type
       * @param  {Array} entries - list of entry objects
       * @param  {Boolean} hasLine - true/false to display col-line div
       * @return {JSX} Col element with stats entry
       */
      function renderCol(type, entries, hasLine) {
        return _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 12, sm: 6, styleName: 'col-' + type + '-wrapper' },
          entries.map(function (entry, idx) {
            return _react2.default.createElement(
              'div',
              {
                key: idx,
                styleName: 'col-label-value' },
              _react2.default.createElement(
                'div',
                { styleName: 'col-' + type },
                _react2.default.createElement(
                  'div',
                  { styleName: 'stats-label' },
                  entry.name
                ),
                entry.link ? _react2.default.createElement(
                  _components.Link,
                  {
                    to: entry.link,
                    title: entry.value,
                    xstrong: true },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'stats-value-link' },
                    entry.value,
                    _react2.default.createElement(_components.LinkIcon, null)
                  )
                ) : _react2.default.createElement(
                  'div',
                  { styleName: 'stats-value' },
                  entry.value
                )
              ),
              hasLine && idx !== entries.length - 1 ? _react2.default.createElement('div', { styleName: 'col-line' }) : null
            );
          })
        );
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'stats' },
        _react2.default.createElement(
          'div',
          { styleName: 'stats-inner' },
          _react2.default.createElement(
            'div',
            { styleName: 'stats-totals' },
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              { styleName: 'stats-header' },
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'stats-title' },
                  'Mutual fund investment profile'
                )
              )
            ),
            _react2.default.createElement('div', { styleName: 'line' }),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              renderCol('left', [{
                name: 'Shareclass ticker',
                value: shareClass.ticker
              }], false),
              renderCol('right', [{
                name: 'Data as of',
                value: _format2.default.formatDate(shareClass.date)
              }], false)
            ),
            _react2.default.createElement('div', { styleName: 'line' }),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              renderCol('left', [{
                name: 'Shareclass name',
                value: shareClass.name
              }], false),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, sm: 6, styleName: 'col-right-wrapper' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'col-label-value' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'col-right' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'stats-label' },
                      '% invested in stocks',
                      _react2.default.createElement(
                        'span',
                        {
                          'data-multiline': true,
                          'data-effect': 'solid',
                          'data-place': 'bottom',
                          'data-for': 'percent-rated',
                          'data-html': true
                          // data-event='click focus'
                          // data-scroll-hide={false}
                          , 'data-tip': _format2.default.tooltipHtml('\n                              The percent of the fund\'s holdings (including\n                              stocks, bonds, and other asset types, and\n                              including both long and short positions) made up\n                              of direct stock investments. Because a fund\'s\n                              gender equality scores are based on the direct\n                              stock holdings in the portfolio, a fund must be \n                              at least 40% invested in stocks to be included\n                              in our database.\n                            ')
                        },
                        _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-info-circle' }),
                        _react2.default.createElement(_reactTooltip2.default, { id: 'percent-rated' })
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'stats-value' },
                      _format2.default.perc(shareClass.percent_rated)
                    )
                  )
                )
              )
            ),
            _react2.default.createElement('div', { styleName: 'line' }),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              renderCol('left', [{
                name: 'Shareclass type',
                value: _format2.default.legalType(shareClass.legal_type)
              }], false),
              renderCol('right', [{
                name: 'Fund net assets',
                value: _format2.default.money(shareClass.fund_net_assets, true, shareClass.currency)
              }], false)
            ),
            _react2.default.createElement('div', { styleName: 'line' }),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              renderCol('left', [{
                name: 'Fund family',
                link: _config2.default.routes.families + '?q=' + gefScoresState.dest,
                value: shareClass.fund_family_name
              }], false),
              renderCol('right', [{
                name: 'Fund category',
                link: '\n                        ' + _config2.default.routes.list + '?fdc=\n                        ' + encodeURIComponent(fund.morningstar_category_name) + '\n                      ',
                value: shareClass.morningstar_category_name
              }], false)
            ),
            _react2.default.createElement('div', { styleName: 'line' }),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              renderCol('left', [{
                name: 'Domicile country',
                value: _format2.default.market(shareClass.market)
              }], false),
              renderCol('right', [{
                name: 'Morningstar-suggested benchmark',
                value: fund.morningstar_primary_benchmark
              }], false)
            ),
            _react2.default.createElement('div', { styleName: 'line' }),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              renderCol('left', [{
                name: 'Total holdings',
                value: _format2.default.number(shareClass.number_of_holding)
              }], false),
              renderCol('right', [{
                name: 'Sustainability mandate',
                value: _format2.default.boolean(shareClass.socially_responsible_fund || "0")
              }], false)
            ),
            _react2.default.createElement('div', { styleName: 'line' }),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              renderCol('left', [{
                name: 'Non-diversification risk',
                value: _format2.default.boolean(shareClass.non_diversified_fund)
              }], false),
              renderCol('right', [{
                name: '\n                        Member of The Forum for Sustainable and Responsible\n                        Investment\n                      ',
                value: _format2.default.boolean(shareClass.ussif === '1.5')
              }], false)
            ),
            _react2.default.createElement('div', { styleName: 'line' }),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              renderCol('left', [{
                name: '# of holdings with Equileap scores',
                value: gefScoresState.gefCount === '-1' ? '0' : gefScoresState.gefCount
              }], false),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, sm: 6, styleName: 'col-right-wrapper' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'col-label-value' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'col-right' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'stats-label' },
                      '% Equileap coverage',
                      _react2.default.createElement(
                        'span',
                        {
                          'data-multiline': true,
                          'data-effect': 'solid',
                          'data-place': 'bottom',
                          'data-for': 'gef-percent-rated',
                          'data-html': true
                          // data-event='click focus'
                          // data-scroll-hide={false}
                          , 'data-tip': _format2.default.tooltipHtml('\n                              The percent of the fund\'s long-position holdings\n                              (including stocks, bonds, and other asset types,\n                              but excluding short positions) made up of stocks\n                              that are covered by the Equileap Company Score\n                              universe. Must be at least 33% for a fund to be\n                              included in our rankings.\n                            ')
                        },
                        _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-info-circle' }),
                        _react2.default.createElement(_reactTooltip2.default, { id: 'gef-percent-rated' })
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'stats-value' },
                      gefScoresState.gefPercentRated === '-100%' ? '0%' : gefScoresState.gefPercentRated,
                      _format2.default.number(fund.gef_rank) === '-1' ? _react2.default.createElement(
                        'span',
                        {
                          'data-multiline': true,
                          'data-effect': 'solid',
                          'data-place': 'bottom',
                          'data-for': 'low-percent-rated',
                          'data-html': true
                          // data-event='click focus'
                          , ref: function ref(_ref8) {
                            _this.refLowPercentRated = _ref8;
                          },
                          'data-tip': _format2.default.tooltipHtml(gefScoresState.gefPercentRated === '-100%' ? '\n                                      None of this fund\'s holdings were scored\n                                      by Equileap. We couldn\'t calculate any\n                                      gender equality scores for this fund,\n                                      and the fund was not included in our\n                                      rankings.\n                                    ' : '\n                                      Less than 1/3 of this fund\'s holdings\n                                      were scored by Equileap. We calculated\n                                      gender equality scores for this fund\n                                      based on\n                                      the ' + gefScoresState.gefPercentRated + ' of\n                                      the fund holdings that had Equileap\n                                      scores, but whenever the score coverage\n                                      is below 1/3 (33%), we remove the fund\n                                      from our rankings to increase accuracy.\n                                    ')
                        },
                        _react2.default.createElement(_components.LinkIcon, {
                          faclass: 'fa-exclamation-triangle fa-2x'
                        }),
                        _react2.default.createElement(_reactTooltip2.default, { id: 'low-percent-rated' })
                      ) : null
                    )
                  )
                )
              )
            ),
            _react2.default.createElement('div', { styleName: 'line' })
          )
        )
      );
    };

    _this.state = {
      viewStats: false,
      showCriteriaSubscoreA: false,
      showCriteriaSubscoreB: false,
      showCriteriaSubscoreC: false,
      showCriteriaSubscoreD: false,
      viewSubscoreRanks: false,
      activeGrouping: DEFAULT_GROUP_TYPE,
      groupsLoaded: true,
      loadingTime: 500
    };
    return _this;
  }

  /**
   * Scroll to top before page loads (prevents loading page scrolled down due
   * to SPA routing weirdness)
   */


  (0, _createClass3.default)(FundGenderScore, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }

    /**
     * Trigger analytics event on page load
     */

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props$params = this.props.params,
          fundId = _props$params.fundId,
          investmentVehicleId = _props$params.investmentVehicleId;

      _analytics2.default.event(_analytics2.default.eventLoadFund(fundId, investmentVehicleId));
    }

    /**
     * Update state with new flag for whether the 'view more' panel is shown
     */


    /**
     * Update state with new active grouping, to be used in displaying
     * percentile ranks and color sliders, and controlled by a form control.
     * Changing form control calls changeActiveGrouping() with the newly
     * selected grouping. Before updating grouping, a timeout is applied, to let
     * Flip component animations complete.
     *
     * @param  {String} newGrouping - Either 'rank', 'peer', or 'group'
     */


    /**
     * Scroll to an element on the page. Need this solution since asyncConnect
     * and anchor links do not play nice. (However we have no anchor links at
     * the moment.) This is called when the page is initially mounting.
     *
     * @param  {String} id - element id to scroll to with offset
     *
     */


    /**
     * DEPRECATED
     */
    // scrollToDomRef = () => {
    //   const myDomNode = ReactDOM.findDOMNode(this.balanceRef)
    //   myDomNode.scrollIntoView()
    // }

    /**
     * Close open tooltips programatically when a new one opens. Used for
     * clickable tooltips that remain open without hover. Tooltip refs are
     * listed here, any unlisted tooltips will not be closed.
     *
     * @param  {String} thisRef - string ref for tooltip that should be
     * programatically closed
     */


    /**
     * Generate HTML for complex tooltips
     *
     * @param  {String} type - the type of tooltip requested
     * @param  {Object} gefScoresState - the score state object with required
     * values, like scores, normalizers, and labels
     * @return {String} String of HTML to be rendered as a tooltip
     */


    /**
     * logic for data for subscore config
     * @param  {obj} gefScoresState results for fund
     * @return {obj}                config for subscore score containers
     */


    /**
     * Render form control to change active grouping. This form control
     * associates with the overall ranking container. Using some constants and
     * the current active grouping from state, a form control is rendered where
     * the current active grouping can be changed. This calls
     * changeActiveGrouping() and updates state, which rerenders ranking
     * containers and form controls using new active grouping.
     *
     * @param  {String} actvGrp - the label of the active grouping, taken from
     * state. Will be 'rank', 'peer', or 'group'
     * @return {JSX} container with clickable form control options, plus an
     * explanatory tooltip
     */


    /**
     * Renders a few descriptive sentences for the overall ranking container.
     * Explains the universe of funds chosen, and the specific ranking (with
     * normalizing group size) that underlies the percentile figure. Includes a
     * link to the List view that changes parameters based on active grouping.
     *
     * @param  {String} actGrp - the label of the active grouping, taken from
     * state. Will be 'rank', 'peer', or 'group'
     * @param  {String} nm - formatted normalizing figure for currently active
     * grouping
     * @param  {Object} scrSt - the score state object (for group labels)
     * @param  {Strinbg} lbl - The long label for the active group type. Will be
     * 'All funds', 'Groups', or 'Categories'.
     * @param  {[type]} actvRnk - formatted rank figure for currently active
     * grouping
     * @return {JSX} container with sentences and link defined by active group
     */


    /**
     * Render the first row of data containers: a pie chart for the overall
     * score, and a ranking container with a color slider and a form control to
     * adjust current active grouping. Each data container also has an alternate
     * if the fund is unscored or unranked.
     *
     * @param  {Object} shareClass - shareclass object
     * @param  {Object} fund - fund object
     * @param  {Object} gefScoresState - score state object
     * @return {JSX} row with data vizualizations and form controls
     */


    /**
     * Render sub-score container.
     */


    /**
     * Render sub-score containers.
     *
     * @param  {Object} shareClass - shareclass object
     * @param  {Object} fund - fund object
     * @param  {Object} gefScoresState - score state object
     * @return {JSX} Grid of data visualizations and Slidedowns
     */


    /**
     * Render function for static content, balance methodology bullet points.
     * Slidedown displayed/hidden by state.showSubscoreACriteria
     *
     * @return {JSX} Slidedown container
     */


    /**
     * Wrapper function to render 'View More Rankings' button and 'Sub-score
     * rankings panel'. Calls render function for button, and renders Slidedown
     * if state.viewSubscoreRanks is true.
     *
     * @param  {Object} shareClass - shareclass object
     * @param  {Object} fund - fund object
     * @param  {Object} gefScoresState - score state object
     * @return {JSX} Wrapper for button and Slidedown
     */


    /**
     * Renders the 'More rankings' button that hides/displays the sub-score rank
     * panel. Styling adjusts based on if state.viewSubscoreRanks is true
     * or false. Also has a compare button
     *
     * @return {JSX} Button with state-updating onClick
     */


    /**
     * Render a container for a sub-score colorbar ranking visualization.
     *
     * @param  {String} sbScrLbl - sub-score label for container styling
     * @param  {Object} gefScoresState - score state object
     * @param  {String} colorbarStyle - string for color bar styling (un/ranked)
     * @param  {String} colorbarLabel - string for colorbar labeling (un/ranked)
     * @param  {<Img>} rankIcon - required icon img
     * @return {JSX} container for single colorbar data visualization
     */


    /**
     * Render sub-score rankings that are displayed in Slidedown when
     * state.viewSubscoreRanks is true. A grid of color sliders.
     *
     * @param  {Object} shareClass - shareclass object
     * @param  {Object} fund - fund object
     * @param  {Object} gefScoresState - score state object
     * @return {JSX} Grid of data visualizations
     */


    /**
     * Wrapper function to render 'View More Button' and 'Stats panel'.
     * Renders button, and renders stats Slidedown if state.viewStats
     * is true.
     *
     * @param  {Object} shareClass - shareclass object
     * @param  {Object} fund - fund object
     * @param  {Object} gefScoresState - score state object
     * @return {JSX} Wrapper for button and Slidedown
     */


    /**
     * Render the stats grid that is displayed in the Slidedown when
     * state.viewStats is true.
     *
     * @param  {[type]} shareClass - the shareclass object
     * @param  {[type]} fund - the fund object
     * @param  {[type]} gefScoresState - the score state object
     * @return {JSX} Container of Rows of Cols that render stat entries
     */

  }, {
    key: 'render',


    /**
     * Main render function
     * @return {JSX} page component
     */
    value: function render() {
      if (!this.props.result) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: false
          })
        );
      } else if (this.props.result && (!this.props.result.fund || !this.props.result.shareClass)) {
        this.context.router.push(_config2.default.routes.notFound);
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: false
          })
        );
      }

      var shareClass = this.props.result.shareClass;
      var title = shareClass.fund_legal_name + ' | Gender equality score';
      var fund = this.props.result.fund;
      var ticker = shareClass.ticker ? shareClass.ticker : 'N';
      var name = _format2.default.sanitize(shareClass.fund_legal_name);
      var urlStart = _config2.default.routes.fund + '/' + name + '/' + ticker;
      var urlEnd = shareClass.fund_id + '/' + shareClass.investment_vehicle_id;
      var url = _config2.default.domain + urlStart + '/gender-lens-score/' + urlEnd;

      /**
       * This genScoreState logic should be moved to happen only once when the
       * fund object is loaded, rather than within the main render function.
       */

      /**
       * Generate a score state object by calculating normalized and formatted
       * figures for use in rendering functions
       *
       * @param  {Object} nrmlzrs - group divisors to normalize for percentile
       * rankings, from config
       * @param  {Object} fnd - fund object with fund values from api
       * @return {Object} score state object with almost everything needed to
       * create tooltips, render containers, etc.
       */
      var genScoreState = function genScoreState(nrmlzrs, fnd) {
        var scores = {};
        var cat = fnd.morningstar_category_name;
        var grp = fnd.category_group;
        scores.dest = encodeURIComponent(fnd.fund_family_name);

        // "out of" figures
        scores.normAllScored = _format2.default.number(nrmlzrs.allScored);
        scores.normGroup = _format2.default.number(nrmlzrs.groups[grp]);
        scores.normPeer = _format2.default.number(nrmlzrs.peers[cat]);

        // coverage
        scores.gefCount = _format2.default.number(fnd.gef_count);
        scores.gefPercentRated = _format2.default.perc(fnd.gef_percent_rated);

        // overall scores
        scores.gefOverallScore = _format2.default.gefScore(fnd.gef_score);
        scores.gefUnnormalizedOverallScore = _format2.default.number(fnd.gef_score, false);

        // overall ranks
        scores.gefOverallRank = _format2.default.number(nrmlzrs.allScored - fnd.gef_rank + 1);
        scores.gefOverallPercentileRank = _format2.default.gefScore(fnd.gef_rank, nrmlzrs.allScored, 0, 1);

        // groups
        scores.gefOverallGroupRank = _format2.default.number(nrmlzrs.groups[grp] - fnd.gef_grp + 1);
        scores.gefOverallGroupPercentileRank = _format2.default.gefScore(fnd.gef_grp, nrmlzrs.groups[grp], 0, 1);

        // categories
        scores.gefOverallPeerRank = _format2.default.number(nrmlzrs.peers[cat] - fnd.gef_peer + 1);
        scores.gefOverallPeerPercentileRank = _format2.default.gefScore(fnd.gef_peer, nrmlzrs.peers[cat], 0, 1);

        // letter grade (based on group ranking)
        scores.gefOverallGroupGrade = _format2.default.gefGrade(_format2.default.gefScore(fnd.gef_grp, nrmlzrs.groups[grp], 0, 1, true));

        // subscores
        var subscoreLabels = ['A', 'B', 'C', 'D'];
        subscoreLabels.forEach(function (el) {
          var lwr = el.toLowerCase();
          // score for subscore, w/ decimal
          scores['subscore' + el + 'ScoreUnnormalized'] = _format2.default.number(fnd['gef_score_' + lwr], false);
          // score for subscore
          scores['subscore' + el + 'Score'] = _format2.default.gefScore(fnd['gef_score_' + lwr]);
          // overall rank for subscore
          scores['subscore' + el + 'Rank'] = _format2.default.number(nrmlzrs.allScored - fnd['gef_rank_' + lwr] + 1);
          // overall percentile rank for subscore
          scores['subscore' + el + 'PercentileRank'] = _format2.default.gefScore(fnd['gef_rank_' + lwr], nrmlzrs.allScored, 0, 1);
          // group rank for subscore
          scores['subscore' + el + 'GroupRank'] = _format2.default.number(nrmlzrs.groups[grp] - fnd['gef_grp_' + lwr] + 1);
          // group percentile rank for subscore
          scores['subscore' + el + 'GroupPercentileRank'] = _format2.default.gefScore(fnd['gef_grp_' + lwr], nrmlzrs.groups[grp], 0, 1);
          // category rank for subscore
          scores['subscore' + el + 'PeerRank'] = _format2.default.number(nrmlzrs.peers[cat] - fnd['gef_peer_' + lwr] + 1);
          // category percentile rank for subscore
          scores['subscore' + el + 'PeerPercentileRank'] = _format2.default.gefScore(fnd['gef_peer_' + lwr], nrmlzrs.peers[cat], 0, 1);
        });

        // show/hide flags
        scores.isUnranked = _format2.default.number(fnd.gef_rank) === '-1';
        scores.isUnscored = _format2.default.number(fnd.gef_score) === '-1';

        // grouping labels
        scores.morningstar_category_name = cat;
        scores.category_group = grp;

        // SRI/USSIF tooltips
        scores.sriTipText = fnd.socially_responsible_fund === 'true' ? 'Fund reports a Sustainability Mandate to Morningstar' : 'No Sustainability Mandate';
        scores.sriTip = _format2.default.tooltipHtml(scores.sriTipText);
        scores.ussifTipText = 'Member of The Forum for Sustainable and Responsible Investment';
        scores.ussifTip = _format2.default.tooltipHtml(scores.ussifTipText);

        return scores;
      };

      // hack in case zero funds from the category are ranked
      if (!_config2.default.gefScoreNormalizers.peers[fund.morningstar_category_name]) {
        _config2.default.gefScoreNormalizers.peers[fund.morningstar_category_name] = 0;
      }
      var gefScoresState = genScoreState(_config2.default.gefScoreNormalizers, fund);

      // Trim trailing zeros from ranks (deals with inconsistent decimals)
      var rankNames = ['gefOverallPercentileRank', 'gefOverallPeerPercentileRank', 'gefOverallGroupPercentileRank', 'subscoreAPercentileRank', 'subscoreAPeerPercentileRank', 'subscoreAGroupPercentileRank', 'subscoreBPercentileRank', 'subscoreBPeerPercentileRank', 'subscoreBGroupPercentileRank', 'subscoreCPercentileRank', 'subscoreCPeerPercentileRank', 'subscoreCGroupPercentileRank', 'subscoreDPercentileRank', 'subscoreDPeerPercentileRank', 'subscoreDGroupPercentileRank'];

      rankNames.map(function (x) {
        gefScoresState[x] = _format2.default.dropStringTrailingZero(gefScoresState[x]);
        return true;
      });

      // subscores are attached to fund for use in returns component
      // (not really normed. to clean up)
      fund.gef_score_norm = gefScoresState.gefOverallScore;
      // fund.gef_score_a_norm = gefScoresState.subscoreAScore
      // fund.gef_score_b_norm = gefScoresState.subscoreBScore
      // fund.gef_score_c_norm = gefScoresState.subscoreCScore
      // fund.gef_score_d_norm = gefScoresState.subscoreDScore

      // Flag to display the diversity EEO if a fund has one to display
      var eeoStatement = _config2.default.ussifFundsDiversityEeo[fund.fund_id] || false;

      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, '', url),
        _react2.default.createElement(_components.FundName, {
          shareClass: shareClass,
          pathname: this.props.location.pathname
        }),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          this.renderOverallScores(shareClass, fund, gefScoresState),
          this.renderSubscoreScores(shareClass, fund, gefScoresState),
          this.renderSubscoreMore(shareClass, fund, gefScoresState),
          _react2.default.createElement(_components.InlineSignup, null)
        ),
        _react2.default.createElement(_components.IyvScorecard, { fund: fund, shareClass: shareClass }),
        _react2.default.createElement(
          'div',
          { styleName: 'container' },
          _react2.default.createElement(
            'div',
            { styleName: 'container-inner' },
            /* if the fund has a diversity-EEO statement from US-SIF */
            eeoStatement ? _react2.default.createElement(_components.DiversityEeoStatement, {
              fundId: fund.fund_id,
              shareclassId: shareClass.investment_vehicle_id,
              shareName: shareClass.name
            }) : null,
            /* if the fund is scored: show list of top/bottom holdings */
            !gefScoresState.isUnscored ? _react2.default.createElement(_components.CompanyList, {
              currency: shareClass.currency,
              holdings: fund.holdings,
              fholdings: fund.fundholdings
            }) : null,
            /* button that shows/hides the "stats" panel */
            this.renderMore(shareClass, fund, gefScoresState)
          )
        ),
        _react2.default.createElement(_components.GetStartedInput, null),
        _react2.default.createElement(_components.FundShareTakeAction, { fund: fund, shareClass: shareClass, url: url })
      );
    }
  }]);
  return FundGenderScore;
}(_react.Component), _class2.propTypes = {
  loading: _react.PropTypes.bool,
  loaded: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.object,
  cart: _react.PropTypes.object
}, _class2.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp)) || _class) || _class) || _class);
exports.default = FundGenderScore;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/FundGenderScore/FundGenderScore.js
// module id = 1304
// module chunks = 0